import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getPercentageValue'
})
export class GetPercentageValuePipe implements PipeTransform {

  transform(baseValue: string, percentage?: string): string {
    let rtn = 0;
    if (baseValue && percentage && percentage != '0') {
      const dblPercentage: number = (parseFloat(percentage) / 100) * parseFloat(baseValue);
      rtn = dblPercentage;
    }
    return rtn.toFixed(2);
  }

}
